import { Application } from "../lib/ui/Application.js";
import { UploadPanel } from "./modules/core/UploadPanel.js";
import { AppStorage } from "./data/AppStorage.js";
import { i18n } from "../lib/globalization/i18n.js";
import { initialize as initializeAppDatatypes } from "./data/app-datatypes.js";
import { Services } from "../lib/services/Services.js";
import { endpoints } from "./modules/core/core-api-endpoints.js";

export class App extends Application {

    constructor(options = {}) {

        super(options);

        this.blockingOperationStarted = super.setBusyFlag;
        this.blockingOperationFinished = super.clearBusyFlag;

        this.dataStorage = new AppStorage();
        initializeAppDatatypes();

        // controls & components

        this.uploadPanel = new UploadPanel(this, {
            uploadFragmentPath: endpoints.fileUpload.uploadFragment,
            mergeFragmentsPath: endpoints.fileUpload.mergeFragments,
            authManager: this.getAuthManager(),
        });

    };

    // prepare() {

    //     return super.prepare()
    //         .then(() => {

    //             let loggedUser = authManager.refreshLoggedUser();

    //             if (!loggedUser)
    //                 return Promise.resolve(false);

    //             return Promise.resolve(true);

    //             // return Promise.all([
    //             // ]);

    //         });

    // };

    // --------------------------------------------------------------------------------------------

    showOffCanvasMenu() {

        this.mainMenu.active = true;
        this.invalidate();

    }

    hideOffCanvasMenu() {

        this.mainMenu.active = false;
        this.invalidate();

    }

    openProjectSelectionModule() {

        this.routeTo('select-active-project');

    };

    openLoginModule() {

        this.routeTo('auth-login');

    };

    openAccountDetailsModule() {

        this.routeTo('account-account-details');

    };

    // --------------------------------------------------------------------------------------------

    getUploadPanel() {

        return this.uploadPanel;

    };

    moduleChanged(module) {

        this.mainMenu.active = false;
        super.moduleChanged(module);

    };

    // --------------------------------------------------------------------------------------------

    _render(vm) {

        const ct = Services.get('templates');
        const app = this;
        const authManager = Services.get('authManager');

        let activeModule = this.getAcitveModule(),
            appLogo = '/img/app-logo.png',
            appName = 'INIS',
            loggedUser = this.authManager.getUser();

        const moduleNode = activeModule ? activeModule.render(vm) : ct.module(['No active module']);
        const moduleTitle = activeModule ? activeModule.getModuleTitle() : '';

        // if (!Array.isArray(moduleNode))
        //     moduleNode = [moduleNode];

        return ct.app('.app', ct.concat([

            // top header

            ct.header([
                ct.nav(ct.concat([
                    renderAppHeaderLeftNavbar(),
                    ct.navgap(),
                    renderAppHeaderRightNavbar(),
                    renderAppHeaderOffCanvasDropdown()
                ])),
            ]),
            moduleNode,
            renderMainMenu(),
            app.controls.map((control) => {
                return control == moduleNode ? null : control.render(vm);
            }),
        ]));

        function renderAppHeaderRightNavbar() {

            return ct.concat([
                collectUserActions().map((action) => {

                    switch (action.appereance) {
                        case 'icon':
                            return ct.iconButton(action.icon, (action.css || '') + '.circle.transparent.l', { title: action.hint, onclick: action.handler });
                        case 'chip':
                            return ct.button(action.label, action.icon, (action.css || '') + '.chip.l', { title: action.hint, onclick: action.handler });
                        default:
                            return ct.button(action.label, action.icon, (action.css || '') + '.l', { title: action.hint, onclick: action.handler });
                    }

                }),
                ct.dropdownButton(null, 'language', '.circle.transparent.l', [
                    ct.dropdownMenu('.left.no-wrap', collectLangActions().map((action) => {
                        return ct.menuItem([ct.link(null, { onclick: action.handler }, [action.label])]);
                    }))
                ]),
            ]);

        }

        function renderAppHeaderOffCanvasDropdown() {

            // created again becaus of use in different part of DOM tree - DOM.removeChild() problem

            return [
                ct.dropdownButton(null, 'ellipsis-vertical', '.circle.transparent.s.m', [
                    ct.dropdownMenu('.no-wrap.bottom.left',
                        ct.concat([
                            collectLangActions(),
                            collectUserActions(),
                        ]).map((action) => {

                            let href = null,
                                props = {},
                                controls = [];

                            if (action.icon)
                                controls.push(ct.icon(action.icon));
                            if (action.label)
                                controls.push(action.label);
                            if (action.handler)
                                props.onclick = action.handler;

                            return ct.menuItem([ct.link(href, props, controls)]);

                        })
                    )
                ])
            ];

        }

        function collectLangActions() {

            return app.getAvailableLocales().map((def) => {

                return {
                    label: def.name,
                    hint: def.name,
                    handler: (e) => { app.setLocale(def.code); }
                };

            });

        };

        function collectUserActions() {

            if (!loggedUser) {

                return [
                    {
                        label: i18n.t('app.label_login'),
                        icon: 'login',
                        hint: i18n.t('app.label_login'),
                        handler: (e) => { app.openLoginModule(); },
                        appereance: 'icon'
                    },
                ];

            }

            let userName = (loggedUser.firstName || '') + ' ' + (loggedUser.lastName || '').toUpperCase(),
                userUsername = loggedUser.username,
                userDisplayName = userName != ' ' ? userName : userUsername;

            return [
                {
                    label: userDisplayName,
                    icon: 'user',
                    handler: (e) => { app.openAccountDetailsModule(); },
                    //appereance: 'chip'
                    css: '.button.text'
                },
                {
                    label: i18n.t('app.label_logout'),
                    icon: 'logout',
                    hint: i18n.t('app.label_login'),
                    handler: (e) => { authManager.logout(); },
                    appereance: 'icon'
                },
            ];

        };

        /**
         * @returns array of domVM nodes
         */
        function renderAppHeaderLeftNavbar() {

            let controls = [
                ct.iconButton('bars', '.circle.transparent', { onclick: () => { app.showOffCanvasMenu(); } }),
                ct.h1('.truncate', [
                    appName + (moduleTitle ? ` - ${moduleTitle}` : ''),
                ]),
            ];

            return controls;

        };

        function renderMainMenu() {

            const visible = app.mainMenu.isActive();

            return [
                ct.div([
                    ct.overlay((visible ? '.active' : ''), { onclick: (e) => { app.hideOffCanvasMenu(); } }),
                    ct.dialog('.left.small' + (visible ? '.active' : ''), [
                        ct.nav([
                            ct.navgap(),
                            ct.iconButton('close', '.circle.transparent', { onclick: (e) => { app.hideOffCanvasMenu(); } }),
                        ]),
                        ct.div('.scroll-y.full-height', [
                            app.mainMenu.render(vm),
                        ]),
                    ]),
                ]),
            ];

        };


    };

}
